// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"finish-stroop_wrapper__31xki","text":"finish-stroop_text__3GaQL","bold":"finish-stroop_bold__2Y8m2","panel":"finish-stroop_panel__F1Xnk"};